import type { ReactNode } from 'react'
import { CustomerAreaLayoutShell, type CustomerAreaNavItem } from '../customer-area'

type PrivacyPageStateShellProps = {
  eyebrow: string
  title: string
  subtitle: string
  navItems: CustomerAreaNavItem[]
  onNavigate: (targetPath: string) => void
  children: ReactNode
}

export const PrivacyPageStateShell = ({
  eyebrow,
  title,
  subtitle,
  navItems,
  onNavigate,
  children,
}: PrivacyPageStateShellProps) => (
  <CustomerAreaLayoutShell
    eyebrow={eyebrow}
    title={title}
    subtitle={subtitle}
    navItems={navItems}
    activeNavId="privacy"
    onNavigate={onNavigate}
  >
    {children}
  </CustomerAreaLayoutShell>
)
